import React, { useState, useMemo, memo } from "react";
import { PACKAGE_RATE_MARKUP_TYPE } from "../../../../../../../constants/Define";
import Button from "../../../../../common/component/Button";
import * as HMS from "../../../../../common/component/Index";
import { Option } from "../../../../../common/component/Select";
import Wrapper from './../../../../../common/component/Wrapper/index';
import { ListComponent } from '../../../../../common/component/Index';
import * as Func from "../../../../../../../helpers/functions";
import { Icon, InputNumber } from "antd";
import AntSelect, { AntOption } from "../../../../../common/component/AntSelect";
import { cloneDeep } from "lodash";

const ListCols = ['rateCode', 'rateName', 'action'];
const ModelObjectFields = ['id', 'ratePlanId', 'refId', 'code', 'name', 'cost', 'order'];

const UpsellConfig = ({t, PackageRateProduction, disabled, ratePlans, onChange }) => {
    const [ratePlan, setRatePlan] = useState(null);

    const onDeleteRateUpsell = (index) => {
      const ratePlanUpSell = cloneDeep(PackageRateProduction?.ratePlanUpSell || []);
  
      let newList = [];
      if(ratePlanUpSell.length > 1){
        ratePlanUpSell.splice(index, 1);
        newList = ratePlanUpSell;
      }
      
      onChange("ratePlanUpSell", newList);
    }
  

    const productTable = useMemo(() => {
        return {
            titleTable: Func.getTitleTable(ListCols, [], ["id"]),
            modelTable: ModelObjectFields,
            componentTable: {
              rateCode: {
                render: (value, record) => record["code"]
              },
              rateName: {
                render: (value, record) => record["name"]
              },
              action: {
                width: 80,
                render: (value, record, index) => (
                  <div className="d-flex-inline">
                    {
                      !disabled && (
                        <Button
                          className="mx-1 border-0"
                          onClick={() => onDeleteRateUpsell(index)}
                        >
                          <Icon type="delete" />
                        </Button>
                      )
                    }
                  </div>
                ),
              },
            },
          }
    }, [PackageRateProduction]);

    const handleChangeRateCode = (id) => {
      const rate = (ratePlans || []).find(x=>x.id === id);
      const rateUpsell = {
        ratePlanId: rate.id,
        refId: rate.refId,
        code: rate.code,
        name: rate.name,
        cost: rate.cost,
        order: rate.order
      }
      setRatePlan(rateUpsell);
    }

    const onChangeRateCode = () => {
      const list = PackageRateProduction?.ratePlanUpSell || [];
  
      // check exists
      if (list.findIndex((x) => x.ratePlanId === ratePlan.ratePlanId) > -1) {
        return;
      }
  
      onChange("ratePlanUpSell", [
        ...list,
        ratePlan
      ]);
  
      // clear
      setRatePlan(null)
    };

    const getRateUpsellNotSelect = () => {
      const bookableNotSelected = (ratePlans || []).filter(x=>x.id !== PackageRateProduction?.ratePlan?.ratePlanId).filter(x => {
        return (PackageRateProduction?.ratePlanUpSell || []).findIndex( y => y.ratePlanId === x.id) < 0;
      });
  
      return bookableNotSelected;
    }

    return (
        <>
            <h3 className="mb-0 mt-5">{t("item.packageRate.selectRateUpsell")}</h3>
            <div className="pr-row">
              <div>
                <div className="pr-row flex-fill">
                  <div className="pr-label">{t("item.packageRate.selectRateCode")}</div>
                  <div className="d-flex flex-fill">
                    <HMS.FormWrapperInputComponent
                      isRequired={false}
                      isValidation={false}
                      typeInput={true}
                      className={"px-3 m-0 w-100"}
                      classLabel={"d-none"}
                      classInputForm={"w-100"}
                    >
                      <AntSelect
                        name={`pk-rate-cote`}
                        placeholder={t("item.packageRate.selectRatePlaceholder")}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        value={ratePlan?.ratePlanId}
                        onChange={(e) => handleChangeRateCode(e)}
                        disabled={PackageRateProduction.hotelId == null}
                      >
                        {getRateUpsellNotSelect().map((item) => (
                          <AntOption key={item.id} value={item.id}>
                            {item.code} - {item.name}
                          </AntOption>
                        ))}
                      </AntSelect>
                    </HMS.FormWrapperInputComponent>
                  </div>
                </div>
              </div>

                <Button
                    className="ml-4"
                    disabled={!ratePlan?.ratePlanId}
                    onClick={onChangeRateCode}
                >
                    {t("item.packageRate.add")}
                </Button>
            </div>

            {productTable && PackageRateProduction?.ratePlanUpSell?.length > 0 && (
                <Wrapper className="w-100">
                    <ListComponent
                        tableKey="table-package-rate-products"
                        rowKey={(record, index) => index}
                        dataSource={Func.getDataSource(PackageRateProduction.ratePlanUpSell, productTable.modelTable)}
                        columns={Func.columnsTable({
                            titleTable: productTable.titleTable,
                            component: productTable.componentTable,
                            itemName: "packageRate",
                        })}
                    />
                </Wrapper>
            )}
        </>
    )
}

export default UpsellConfig;